var map = {
	"./add.svg": 349,
	"./add_queue.svg": 350,
	"./album.svg": 351,
	"./archive.svg": 352,
	"./audio_file.svg": 353,
	"./bell.svg": 354,
	"./blue_dot_icon.svg": 355,
	"./caret_down.svg": 356,
	"./caret_up.svg": 357,
	"./cart.svg": 358,
	"./check.svg": 359,
	"./circle-minus.svg": 360,
	"./close.svg": 361,
	"./cloud-upload.svg": 362,
	"./collection.svg": 363,
	"./copy.svg": 364,
	"./delete.svg": 365,
	"./download.svg": 366,
	"./edit.svg": 367,
	"./editor_admin.svg": 368,
	"./expand_collapse.svg": 369,
	"./favorite.svg": 370,
	"./folder-open.svg": 371,
	"./genre.svg": 372,
	"./info_panel.svg": 373,
	"./info_round.svg": 374,
	"./init_editor.svg": 375,
	"./instrument.svg": 376,
	"./link.svg": 377,
	"./list-plus.svg": 378,
	"./log-out.svg": 379,
	"./menu.svg": 380,
	"./natural_language.svg": 381,
	"./now_playing.svg": 382,
	"./open_editor.svg": 383,
	"./pause.svg": 384,
	"./playlist_reorder.svg": 385,
	"./playlists.svg": 386,
	"./queue.svg": 387,
	"./quick_filter.svg": 388,
	"./radio.svg": 389,
	"./receipt.svg": 390,
	"./remove.svg": 391,
	"./rotate-cw.svg": 392,
	"./save-all.svg": 393,
	"./save.svg": 394,
	"./scroll-text.svg": 395,
	"./search.svg": 396,
	"./settings.svg": 397,
	"./share_add_person.svg": 398,
	"./share_copy_link.svg": 399,
	"./similar_tracks.svg": 400,
	"./sort.svg": 401,
	"./split.svg": 402,
	"./tag.svg": 403,
	"./text_search.svg": 404,
	"./track.svg": 405,
	"./triangle-alert.svg": 406,
	"./triangle.svg": 407,
	"./upload.svg": 408,
	"./user-minus.svg": 409,
	"./user-shield.svg": 410,
	"./variation.svg": 411,
	"./volume.svg": 412,
	"./volume_muted.svg": 413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 816;